export const GET_DEVICES_DATA = 'USER_DEVICES_DATA';
export const GET_DEVICE_DATA = 'USER_DEVICE_DATA';
export const PUT_CURRENT_USER_DEVICE_ID = 'PUT_CURRENT_USER_DEVICE_ID';
export const GET_DEVICE_SITUATION = 'GET_DEVICE_SITUATION';
export const SET_DEVICE_SITUATION = 'SET_DEVICE_SITUATION';
export const SET_STORE_DATA = 'SET_STORE_DATA';
